import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {error: null};
  }

  static getDerivedStateFromError(error) {
    return {error};
  }

  componentDidCatch(error, info) {
    console.error('Prepspire Vocabulary Trainer rendering error:', error, info);
  }

  render() {
    const {error} = this.state;

    if (error) {
      return (
        <main className="simple-auth-page">
          <section className="error-boundary card-panel">
            <span className="eyebrow">Prepspire Vocabulary Trainer</span>
            <h1>Unable to load the application</h1>
            <p>Something went wrong while rendering the app. Your saved session was not changed.</p>
            <details>
              <summary>Technical details</summary>
              <pre>{error.message || String(error)}</pre>
            </details>
            <div className="form-actions">
              <button className="button secondary" onClick={() => this.setState({error: null})}>
                Try again
              </button>
              <button className="button primary" onClick={() => window.location.reload()}>
                Refresh page
              </button>
            </div>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;